import React from "react";

import InputComponent from "../../UI/InputComponent/InputComponent";
import DatePickerComponent from "../../UI/DatePicker/DatepickerComponent";

import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";

import DownloadAttachment from "../../UI/DownloadAttachment/DownloadAttachment";

const Revizija = ({
  values,
  handleInputChange,
  handleDateChange,
  handleSingleFileUpload,
  handleMultiFileUpload,
  update,
  downloadAttachments,
  removeAttachment,
  handleNumberInput,
}) => {
  return (
    <div>
      <br></br>
      <InputComponent
        onChange={handleInputChange}
        value={values.nazivRevDrustva}
        id="nazivRevDrustva"
        name="nazivRevDrustva"
        controlLabel={
          "Naziv revizorskog društva / Ime i prezime samostalnog revizora"
        }
      />
    <div style={{backgroundColor: 'whitesmoke', padding: 16, marginBottom: 16}}>
      <InputComponent
        onChange={handleNumberInput}
        value={values.registarskiBroj}
        disabled={values.oib}
        name="registarskiBroj"
        id="regBroj"
        controlLabel={"Registarski broj"}
      />
      <InputComponent
        onChange={handleNumberInput}
        value={values.oib}
        disabled={values.registarskiBroj}
        name="oib"
        id="oibDrustva"
        controlLabel={"OIB"}
      />
      {!update ? <p style={{fontStyle: "italic", marginBottom: "0px"}}>Napomena: Nije moguće unijeti oba podatka u isto vrijeme.</p> : null}
    </div>
      <DatePickerComponent
        id="datSklapanjaUgovora"
        handleDayClick={handleDateChange}
        controlLabel={"Datum sklapanja ugovora"}
        index={{ id: "datSklapanjaUgovora" }}
        width={"100%"}
        value={values.datSklapanjaUgovora}
      />
      <InputComponent
        onChange={handleInputChange}
        value={values.brojUgovora}
        name="brojUgovora"
        id="brojUgovora"
        controlLabel={"Broj ugovora"}
      />
      <InputComponent
        onChange={handleInputChange}
        value={values.predmetUgovora}
        name="predmetUgovora"
        id="predmetUgovora"
        controlLabel={"Predmet ugovora"}
      />
      <InputComponent
        onChange={handleInputChange}
        value={values.ugovaratelj}
        name="ugovaratelj"
        id="ugovaratelj"
        controlLabel={"Ugovaratelj - subjekt od javnog interesa"}
      />
      <InputComponent
        onChange={handleInputChange}
        value={values.zajRevizija}
        name="zajRevizija"
        id="zajRevizija"
        controlLabel={"Zajednička revizija"}
      />
      <div style={{ padding: 4, width: "100%", backgroundColor: '#f8f9fa' , marginBottom: '16px'}}>
        <p style={{fontWeight: 500, margin: 0, padding: 0}}>Prilozi
        </p>
        <ul>
          <li>dopušteni formati: PDF</li>
          <li>maksimalna veličina datoteke - 10MB</li>
        </ul>
      </div>
      <label>Dokumenti</label>
      <Upload
        multiple
        id={"dokumenti"}
        beforeUpload={() => {
          return false;
        }}
        accept={"application/pdf"}
        onChange={(file) => handleMultiFileUpload(file, "dokumenti")}
        fileList={values.dokumenti}
      >
        <Button className={"upload-btn"} style={{ marginBottom: "16px" }}>
          <UploadOutlined /> Odaberite datoteku
        </Button>
      </Upload>
      <InputComponent
        onChange={handleInputChange}
        value={values.napomena}
        name="napomena"
        id="napomena"
        controlLabel={"Napomena"}
      />

      {update && values.dokumentiOld.length > 0 && (
        <>
          <br></br>
          <span>
            <b>Prilozi učitani na unosu evidencije:</b>
          </span>
          <br></br>

          {values.dokumentiOld.map((element) => {
            return (
              <DownloadAttachment
                id={element.idPredPolja}
                downloadAttachments={downloadAttachments}
                removeAttachment={removeAttachment}
                contentType={element.contentType}
                fileName={element.fileName}
                group={"dokumentiOld"}
                label={"Dokumenti"}
              />
            );
          })}
        </>
      )}
    </div>
  );
};

export default Revizija;
